// extracted by mini-css-extract-plugin
module.exports = {"transparent":"Navbar_transparent__ri1bB","nav-text":"Navbar_nav-text__2blR3","nav-dropdown":"Navbar_nav-dropdown__19yth","MuiPaper-root":"Navbar_MuiPaper-root__3WUu7"};